<template>
  <RadioGroup v-model="form.accountType">
    <RadioGroupLabel class="text-base font-medium text-gray-900">
      What are your services?
    </RadioGroupLabel>

    <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
      <RadioGroupOption
        v-for="accountType in accountTypes"
        :key="accountType.id"
        v-slot="{ checked, active }"
        as="template"
        :value="accountType.id"
      >
        <div :class="[checked ? 'border-transparent' : 'border-gray-300', active ? 'ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none']">
          <div class="flex-1 flex">
            <div class="flex flex-col">
              <RadioGroupLabel
                as="span"
                class="block text-sm font-medium text-gray-900"
              >
                {{ accountType.title }}
              </RadioGroupLabel>
              <RadioGroupDescription
                as="span"
                class="mt-1 flex items-center text-sm text-gray-500"
              >
                {{ accountType.description }}
              </RadioGroupDescription>
            </div>
          </div>
          <CheckCircleIcon
            :class="[!checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']"
            aria-hidden="true"
          />
          <div
            :class="[active ? 'border' : 'border-2', checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']"
            aria-hidden="true"
          />
        </div>
      </RadioGroupOption>
      <div v-if="form.accountType === 'guide'">
        <a
          target="_blank"
          :href="route('start')"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >Need help starting a company?</a>
      </div>
    </div>
  </RadioGroup>
</template>

<script>

import {
  RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption,
} from '@headlessui/vue';
import { CheckCircleIcon, CheckIcon } from '@heroicons/vue/24/solid';
import JetCheckbox from '@/Jetstream/Checkbox';

export default {
  name: 'Services',

  components: {
    JetCheckbox,
    RadioGroup,
    RadioGroupDescription,
    RadioGroupLabel,
    RadioGroupOption,
    CheckCircleIcon,
    CheckIcon,
  },

  props: ['form', 'accountTypes'],
  emits: ['update:form'],

  computed: {
    form: {
      get() {
        return this.form;
      },
      set(value) {
        this.$emit('update:form', value);
      },
    },
  },
};
</script>
